import React from "react";
import { NavLink, Link } from "react-router-dom";
import "./headerHV.css";
import logo from "../../assets/logo.png";


export default function HeaderHV() {
  return (
    <header className="hv-header">
      {/* Logo + tiêu đề bấm về trang chủ (/) */}
      <Link to="/" className="hv-left" style={{ textDecoration: "none" }}>
        <img className="hv-logo" src={logo} alt="Hùng Vương" />
        <div className="hv-title">
          <div className="hv-name">HỆ THỐNG Y TẾ HÙNG VƯƠNG GIA LAI</div>
          <div className="hv-slogan">Thân thiện - Chuyên nghiệp - Chu đáo</div>
        </div>
      </Link>

      <nav className="hv-nav">
        <NavLink to="/" className={({isActive}) => `nav-item ${isActive ? "active" : ""}`}>
          Trang chủ
        </NavLink>

        {/* Nếu sau này có route riêng thì đổi thành NavLink/Link */}
        <a className="nav-item" href="#">Nhân lực</a>
        <a className="nav-item" href="#">CSCL</a>

        <div className="hv-dropdown">
          {/* <button className="hv-dropbtn">Tổng quát KCB ▾</button>
          <div className="hv-dropdown-content">
            <a href="#">Báo cáo tổng hợp</a>
            <a href="#">Thống kê chi tiết</a>
          </div> */}
        </div>

        <NavLink
          to="/lich-kham"
          className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
        >
          Lịch khám
        </NavLink>

        <a className="nav-item" href="#">BC Ngày</a>

        <div className="hv-switch">
          <label className="switch">
            <input type="checkbox" />
            <span className="slider round"></span>
          </label>
          <span className="hv-switch-label">QL Phòng</span>
        </div>
      </nav>
    </header>
  );
}
